import { useState } from 'react';
import { Row, Col, Form, InputGroup } from 'react-bootstrap';
import AdditionalInformationField from '../../fields/AdditionalInformationField';
import SubmissionTypeField from '../../fields/SubmissionTypeField';
import { MIN_PLEDGE } from '../../../../constants/constants';
import IncomeMeasurementSelector from '../../common/IncomeMeasurementSelector';
import CurrencyField from '../../fields/CurrencyField';
import Required from '../../../../utils/Required';

const OtherFundSection = ({
  state,
  otherFundType,
  onOtherFundTypeChange,
  incomeMeasurementType,
  onIncomeMeasurementTypeChange,
  incomeMeasurementPercentage,
  onIncomeMeasurementPercentageChange,
  pledgeAmount,
  onPledgeAmountChange,
  submissionType,
  onSubmissionTypeChange,
  additionalInformation,
  onAdditionalInformationChange,
  isSubmitting,
}) => {
  const [touched, setTouched] = useState(false);

  const getOtherFundTypeError = () => {
    if (!otherFundType) return 'Fund Type Name is required.';
    if (otherFundType.length > 20) return `Fund Type Name must be less than 20 characters.`;
    return null;
  };
  const errorMessage = getOtherFundTypeError();

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <InputGroup>
              <Form.FloatingLabel label={<Required>Fund Type Name</Required>} controlId="other-fund-type">
              <Form.Control
                type="text"
                maxLength={20}
                value={otherFundType}
                required
                disabled={isSubmitting}
                isInvalid={!!errorMessage && touched}
                onChange={(e) => {
                  setTouched(true);
                  onOtherFundTypeChange(e.target.value);
                }}
                onBlur={() => setTouched(true)}
              />
              <Form.Control.Feedback type="invalid">
                {errorMessage}
              </Form.Control.Feedback>
              </Form.FloatingLabel>
            </InputGroup>
            <Form.Text muted className="float-end">{otherFundType.length}/20</Form.Text>
          </Form.Group>
        </Col>
      </Row>

      <hr/>

      {/* Income Measurement Type */}
      <Row className="mb-3">
        <Col>
          <IncomeMeasurementSelector
            state={state}
            incomeMeasurementType={incomeMeasurementType}
            onIncomeMeasurementTypeChange={onIncomeMeasurementTypeChange}
            incomeMeasurementPercentage={incomeMeasurementPercentage}
            onIncomeMeasurementPercentageChange={onIncomeMeasurementPercentageChange}
          />
        </Col>
      </Row>

      <hr/>

      {/* Pledge Amount */}
      <Row>
        <h4>Benefit Amount</h4>
        <Col md={6}>
          <CurrencyField
            min={MIN_PLEDGE}
            fieldName="Pledge Amount"
            value={pledgeAmount}
            onChange={onPledgeAmountChange}
            isSubmitting={isSubmitting}
            required
          />
        </Col>
      </Row>

      <hr/>

      {/* Additional Information */}
      <Row>
        <Col>
          <AdditionalInformationField
            value={additionalInformation}
            onChange={onAdditionalInformationChange}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>
    </>
  );
};

export default OtherFundSection;